/* *********************************************************************************************************** */
/* *********************************************************************************************************** */

export const certificationsList = [
  {
    title: "ChatGPT and LangChain: The Complete Developer's Masterclass",
    provider: "Udemy",
    platform: "Udemy",
    issueDate: "March 2026",
    credentialUrl: "",
    skills: ["ChatGPT", "LangChain", "AI", "LLM"],
    show: true,
  },
  {
    title: "NestJS: The Complete Developer's Guide",
    provider: "Udemy",
    platform: "Udemy",
    issueDate: "April 2024",
    credentialUrl: "https://www.udemy.com/certificate/UC-332fddfd-977b-49f7-836c-864d9715e477/",
    skills: ["NestJS", "Node.js", "TypeScript"],
    show: true,
  },
  {
    title: "AWS Certified Developer Associate 2024 New DVA-C02",
    provider: "Udemy",
    platform: "Udemy",
    issueDate: "July 2024",
    credentialUrl: "https://www.udemy.com/certificate/UC-a060f9d6-f8cc-49c8-92d3-88fe18bbf9bf/",
    skills: ["Amazon AWS", "AWS Certified Developer Associate"],
    show: true,
  },
  {
    title: "Docker and Kubernetes: The Complete Guide",
    provider: "Udemy",
    platform: "Udemy",
    issueDate: "May 2023",
    credentialUrl: "https://www.udemy.com/certificate/UC-3ee4c7ea-0991-4b7c-9895-64acf85ed20d/",
    skills: ["Docker", "Kubernetes", "Containerization"],
    show: true,
  },
];
